import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { SignInData } from '../model/signInData';
import { PrivilegeService } from '../services/privilege/privilege.service';
import { RoleService } from '../services/role/role.service';
import { AppSettings } from '../Constant/AppSettings';
import { CommonFunctions } from '../Utilities/CommonFunctions';
import { Subscription, interval } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit, OnDestroy {
  isFormValid = false;
  areCredentialsInvalid = false;
  isLoading: boolean = false;
  disabled: boolean = false;
  error = '';
  showTwoFactorAuth: boolean = false;
  userStatus: boolean = true;
  pendingId: string | null = null;
  private pollSubscription?: Subscription;
  private pollStartTime = 0;
  private readonly POLL_INTERVAL_MS = 3000;
  private readonly POLL_TIMEOUT_MS = 5 * 60 * 1000;
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private privilegeService: PrivilegeService,
    private roleService: RoleService,
  ) { }

  ngOnInit() {

  }

  ngOnDestroy(): void {
    this.stopTwoFactorPolling();
  }

  //LOGIN
  onSubmit(signInForm: NgForm) {
    if (!signInForm.valid) {
      this.isFormValid = true;
      this.areCredentialsInvalid = false;
      return;
    }
    this.login(signInForm);
  }

  private login(signInForm: NgForm) {
    this.showProgressBar()
    const signInData = new SignInData(
      signInForm.value.username,
      signInForm.value.password
    );
    var data = { data: JSON.parse(JSON.stringify(signInData)) };
    this.authenticationService.authenticate(data).subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        console.log('Token --->> ' + json.data.token);
        console.log('Login API Response --->> ' + JSON.stringify(json));
        if (json.response.status == 'SUCCESS') {
          if (json.data.twoFactor && json.data.pendingId) {
            this.pendingId = json.data.pendingId;
            this.userStatus = true;
            this.showTwoFactorAuth = true;
            this.startTwoFactorPolling();
          } else {
            this.completeLogin(json.data.user, json.data.token);
          }
        } else {
          console.log(json);
          this.error = json.response.displayMessage;
          console.log(this.error);
          // this.router.navigate(['/login']);
        }
        this.hideProgressBar()
      },
      (error) => {
        console.log('There was an error');
        console.log(error);
        this.hideProgressBar();
      }
    );
  }

  private completeLogin(user: any, token: any) {
    this.showTwoFactorAuth = false;
    CommonFunctions.setToken(token)
    CommonFunctions.setUser(user)
    this.authenticationService.TOKEN = token;
    this.listPrivilegeGroups(user)
  }

  startTwoFactorPolling() {
    this.stopTwoFactorPolling();
    this.pollStartTime = Date.now();
    this.pollSubscription = interval(this.POLL_INTERVAL_MS).subscribe(() => {
      if (!this.pendingId) {
        return;
      }
      if (Date.now() - this.pollStartTime > this.POLL_TIMEOUT_MS) {
        this.stopTwoFactorPolling();
        this.showTwoFactorAuth = false;
        this.error = 'Login request expired. Please try again.';
        return;
      }
      this.authenticationService.get2FAStatus(this.pendingId).subscribe(
        (response) => {
          var json = JSON.parse(JSON.stringify(response));
          if (json.response.status !== 'SUCCESS') {
            return;
          }
          const status = json.data.status;
          if (status === 'APPROVED') {
            this.stopTwoFactorPolling();
            this.completeLogin(json.data.user, json.data.token);
          } else if (status === 'DENIED') {
            this.stopTwoFactorPolling();
            this.userStatus = false;
          } else if (status === 'EXPIRED') {
            this.stopTwoFactorPolling();
            this.showTwoFactorAuth = false;
            this.error = 'Login request expired. Please try again.';
          }
        },
        (error) => {
          console.log('Error polling 2FA status', error);
        }
      );
    });
  }

  stopTwoFactorPolling() {
    this.pollSubscription?.unsubscribe();
    this.pollSubscription = undefined;
  }

  listPrivilegeGroups(user: any) {
    this.isLoading = true;
    this.roleService.listPrivilegeGroups().subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        console.log('Privileges --->> ' + JSON.stringify(json));
        if (json.response.status == 'SUCCESS') {
          let temp: any[] = [];
          for (let index = 0; index < json.data.length; index++) {
            let privilegeGroup = json.data[index];
            // console.log(privilegeGroup)
            for (let indexj = 0; indexj < privilegeGroup.privileges.length; indexj++) {
              let privilege = privilegeGroup.privileges[indexj];
              temp.push({
                id: privilege.id,
                name: privilege.name,
                value: false
              })
            }

          }

          this.privilegeService.privileges = temp;
          // if (user.roles.length > 0) {
          //   for (let index = 0; index < user.roles.length; index++) {
          //     if (user.roles[index].name === 'SUPER_ADMIN') {
          //       this.privilegeService.setPrivileges(user.role[0].id)
          //     } else {

          //     }
          //   }
          // }

          this.privilegeService.setPrivileges(user.privileges)
          this.router.navigate(['/home']);
        }


        this.hideProgressBar();
      },
      (error) => {
        console.log(AppSettings.ERROR_MSG);
        console.log(error);
        this.hideProgressBar();
      }
    );
  }


  showProgressBar() {
    this.isLoading = true;
    this.disabled = true;
  }

  hideProgressBar() {
    this.isLoading = false;
    this.disabled = false;
  }

}
